import { render, staticRenderFns } from "./ImageCaption.vue?vue&type=template&id=f015466e&scoped=true&lang=html&"
import script from "./ImageCaption.vue?vue&type=script&lang=js&"
export * from "./ImageCaption.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaption.vue?vue&type=style&index=0&id=f015466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f015466e",
  null
  
)

export default component.exports